<template lang="pug">
    .conjunto-datos
        span.title {{ title }}
        .body
            //- span :
            strong(v-if='model') {{ formattedValue }}
            strong.danger(v-else='') {{ dangerMessage }}
</template>

<script>
export default {
  name: 'datos_conjuntos',
  props: {
    title: String,
    model: String,
    capitalize: Boolean,
    dangerMessage: String
  },
  computed: {
    formattedValue () {
      return this.capitalize ? this.model.toUpperCase() : this.model;
    }
  }
}
</script>

<style lang="stylus" scoped>
.conjunto-datos
  margin-bottom: 1.2rem;
  align-items: center;
  .title
      font-size 1.1rem
      margin-bottom: 0px !important
  // .body
  //     span
  //         margin-right 0.5rem
  .subtitle:not(:last-child), .title:not(:last-child) {
    margin-bottom: 1.5rem;
  }


</style>



// WEBPACK FOOTER //
// Component_Datos_Conjuntos.vue?c343a946